<!-- 评价管理 -->
<template>
	<div>
		<div class="container">
			<e-search :count="7" :data="filterInfo.data" :field-list="filterInfo.fieldList"
				:list-type-info="listTypeInfo" @handleFilter="handleFilter"  @handleReset="handleReset"></e-search>
		</div>
		<div class="container">
			<div class="handle-box">
				<table-list :loading="loading" :table-data="tableData" :table-label="tableLabel"
					@handleButton="handleButton" @handleSortChange="handleSortChange"
					@handleSelectionChange="handleSelectionChange">
					<!-- eslint-disable-next-line -->
					<template v-slot:company="slot">
						<div v-if="slot.scope.row.replyStatus == '0'">
							<span class='reply' @click="toReply(slot.scope.row)">回复</span>
						</div>
						<div style='font-size:12px;cursor: pointer' v-else>已回复</div>
					</template>
					<template v-slot:showQualityDim="slot">
						<div>
							<el-rate v-model="slot.scope.row.quality" :colors="colors" :disabled="disabled"></el-rate>
						</div>
 					</template>
					<template v-slot:showCprDim="slot">
						<div>
							<el-rate v-model="slot.scope.row.costPerformance" :colors="colors" :disabled="disabled"></el-rate>
						</div>
 					</template>
					<template v-slot:feedback="slot">
						<e-tooltip :content="slot.scope.row.feedback" :set-length="26"/>
 					</template>
				</table-list>
				<div class="pagination">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]" layout="total, sizes, prev, pager, next, jumper"
						:current-page="productTagPage.pageNum" :page-size="productTagPage.pageSize"
						:total="productTagPage.pageTotal"  >
					</el-pagination>
				</div>
			</div>
			</div>
		<el-dialog title="回复内容" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" :modal-append-to-body="false">
			<el-input v-model="feedBack" placeholder="请输入内容" type="textarea"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="confirmReply">确 定</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import eSearch from "../../components/common/e-search";
	import tableList from "../../components/common/e-table-list";
	import eTooltip from "../../components/common/e-tooltip";
	import api from "../../api/order";

	export default {
		data() {
			return {
				colors: ['#F0250F', '#F0250F', '#F0250F'],
				dialogVisible: false,
				loading: false,
				feedBack: '',
				tableOption: [],
				tableData: [],
				tableLabel: [{
						label: '订单编号',
						param: 'orderNo',
						align: 'center',
						width:'170',
					},
					{
						label: '采购商名称',
						param: 'companyName',
						align: 'center'
					},
					{
						label: '评价类型',
						param: 'auditStatus',
						align: 'center',
						width:'70',
						render: (row) => {
							if (row.feedbackType === 0) {
								return '初评'
							} else if (row.feedbackType === 1) {
								return '回复'
							} else {
								return '复评'
							}
						}
					},
					{
						label: '评价时间',
						param: 'createTime',
						align: 'center',
						width:'140',
					},
					{
						label: '质量（5星满）',
						param: 'detailList',
						align: 'center',
						slot:'showQualityDim'
					},
					{
						label: '性价比（5星满）',
						param: 'detailList',
						align: 'center',
						slot:'showCprDim'
					},
					{
						label: '评价内容',
						param: 'feedback',
						align: 'center',
						slot:'feedback',
						width:'180',
					},
					{
						label: '操作',
						param: 'operation',
						align: 'center',
						width:'70',
						slot: 'company'

					},
				],
				productTagPage: {
					pageNum: 1,
					pageSize: 10,
					pageTotal: 0,
				},
				disabled:true,
				queryData:{
					orderNo: null,
					companyName: null,
					auditStatus: 0,
					feedbackType:null,//评价类型
					createTime: null,
					dateTime: null,
					range: null,
					qualityDim:null,//质量
					cprDim:null,//性价比.
					imageStatus:null,//是否有图
					pageNum:1,
					pageSize:10,
				},
				filterInfo: {
					data: {
						orderNo: null,
						companyName: null,
						auditStatus: 0,
						feedbackType:null,//评价类型
						createTime: null,
						dateTime: null,
						range: null,
						qualityDim:null,//质量
						cprDim:null,//性价比
						imageStatus:null,//是否有图
					},
					fieldList: [{
							label: '订单编号',
							type: 'input',
							value: 'orderNo'
						},
						{
							label: '采购商名称',
							type: 'input',
							value: 'companyName'
						},
						{
							label: '评价类型',
							type: 'select',
							value: 'feedbackType',
							list: 'commentType'
						},
						{
							label: '评价时间',
							type: 'date',
							value: 'range',
							dateType: 'datetimerange',
							defaultTime: ['00:00:00', '23:59:59'],
							valueFormat: "yyyy-MM-dd HH:mm:ss",
						},
						{
							label: '质量',
							type: 'select',
							value: 'qualityDim',
							list: 'qualityDimList'
						},
						{
							label: '性价比',
							type: 'select',
							value: 'cprDim',
							list: 'cprDimList'
						},
						{
							label: '是否有图',
							type: 'select',
							value: 'imageStatus',
							list: 'ynList'
						},
					],
					/**配置项 */
					btnStyle: [{
							icon: 'el-icon-search',
							text: '过滤',
							type: 'primary'
						},
						{
							icon: 'el-icon-refresh',
							text: '重置'
						}
					]
				},
				listTypeInfo: {
					statusList: [{
							id: 1,
							name: '全部'
						},
						{
							id: 2,
							name: '成功'
						},
						{
							id: 3,
							name: '失败'
						},
					],
					typeList: [{
							id: 1,
							name: '全部'
						},
						{
							id: 2,
							name: '商品批量新增'
						},
						{
							id: 3,
							name: '商品批量修改'
						},
						{
							id: 4,
							name: '协议价批量调价'
						}
					],
					ynList: [{
							id: null,
							name: '全部'
						},
						{
							id: 1,
							name: '是'
						},
						{
							id: 0,
							name: '否'
						},
					],
					qualityDimList:[
						{id: null, name: '全部'},
						{id: 5, name: '五星'},
						{id: 4, name: '四星'},
						{id: 3, name: '三星'},
						{id: 2, name: '二星'},
						{id: 1, name: '一星'},
					],
					cprDimList:[
						{id: null, name: '全部'},
						{id: 5, name: '五星'},
						{id: 4, name: '四星'},
						{id: 3, name: '三星'},
						{id: 2, name: '二星'},
						{id: 1, name: '一星'},
					],
					//评级类型
					commentType: [
						{id: null, name: '全部类型'},
						{id: 0, name: '初评'},
						{id: 1, name: '回复'},
						{id: 2, name: '复评'},
					],
				},
				replyData: {},
				parentId: ''
			};
		},
		components: {
			eSearch,
			tableList,
			eTooltip
		},
		mounted() {
			this.queryFeedbackManagementList();
		},
		methods: {
			toReply(data) {
				this.replyData = data;
				this.dialogVisible = true;
			},
			//回复
			confirmReply() {
				let param = {
					feedback: this.feedBack,
					parentId: this.nextFeedbackFlag(this.replyData),
					feedbackType: this.replyData.nextFeedbackVO ? 1 : 2,
					groupId: this.replyData.feedbackId,
				}
				api.addMoreFeedback(param).then((res) => {
					if (res.code == '200') {
						this.$message.success('回复成功');
						this.handleClose();
						this.queryFeedbackManagementList();
					} else {
						// this.$message.error(res.message)
					}
				})
			},
			//回调查看是否有评价记录
			nextFeedbackFlag(param) {
				if (param.nextFeedbackVO) {
					this.parentId = param.nextFeedbackVO.feedbackId;
					return this.nextFeedbackFlag(param.nextFeedbackVO);
				} else {
					return this.parentId ? this.parentId : param.feedbackId;
				}
			},
			handleClose() {
				this.dialogVisible = false;
				this.feedBack = '';
			},
			//查询列表
			queryFeedbackManagementList() {
				api.queryFeedbackManagementList(this.queryData).then((res) => {
					if (res.code == '200') {
						this.tableData = res.data.records;
						this.productTagPage.pageTotal = res.data.total;
						this.tableData.forEach(item => {
							item.detailList.forEach(setScoreItem => {
								if (Number(setScoreItem.dimensions) === 101) {
									this.$set(item, 'quality', setScoreItem.levelId);//质量
								}
								if (Number(setScoreItem.dimensions) === 102) {
									this.$set(item, 'costPerformance', setScoreItem.levelId);//性价比
								}
							})
						})
					} else {
						this.$message.error(res.message)
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			handleImportOrder() {},
			handleReset(){
				this.queryData = {
					orderNo: null,
					companyName: null,
					auditStatus: 0,
					feedbackType: null,//评价类型
					createTime: null,
					dateTime: null,
					range: null,
					qualityDim: null,//质量
					cprDim: null,//性价比.
					imageStatus:null,//是否有图
					pageNum: 1,
					pageSize: 10,
				}
				this.queryFeedbackManagementList();
			},
			//    搜索操作
			handleFilter(val) {
				this.queryData.orderNo = val.orderNo;
				this.queryData.companyName =  val.companyName;
				this.queryData.feedbackType =  val.feedbackType;
				this.queryData.createTime =  val.createTime;
				this.queryData.dateTime =  val.dateTime;
				this.queryData.timeStart =  val.range ? val.range[0] : null;
				this.queryData.timeEnd =  val.range ? val.range[1] : null;
				this.queryData.qualityDim = val.qualityDim ;//质量
				this.queryData.cprDim = val.cprDim; //性价比
				this.queryData.imageStatus = val.imageStatus; //性价比
				this.queryData.pageNum = 1; //性价比
				this.queryFeedbackManagementList();
			},
			//    表格操作
			handleButton() {},
			handleSortChange() {},
			handleSelectionChange() {},
			//    分页操作
			handleSizeChange(val) {
				this.queryData.pageSize = val;
				this.queryData.pageNum = 1
				this.queryFeedbackManagementList();
			},
			handleCurrentChange(val) {
				this.queryData.pageNum = val;
				this.queryFeedbackManagementList();
			},
		}
	}
</script>
<style lang='scss' scoped>
	.container {
		margin-bottom: 10px;

		.sku-img {
			width: 70px;
			height: 70px;
		}
	}

	.handle-box {
		margin-top: 20px;
		// margin-bottom: 20px;
	}

	.pagination {
		text-align: right;
	}

	.reply {
		font-size: 12px;
		color: rgb(37, 135, 255);
		cursor: pointer;
	}

	.reply:hover {
		/* text-decoration: underline; */
	}

	::v-deep .el-table .cell {
		font-size: 12px;
	}
</style>
